<!-- Иконка закрепления показателя в кратком результате. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="stroke"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M12 17v5" />
    <path d="M6 3h12" />
    <path d="m8 3 1 7-3 4h12l-3-4 1-7" />
  </svg>
</template>

<script>
export default {
  name: "PinIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
